<template>
    <div>
        <CRow>
            <CCol md="12" class="pad-r-0 pad-l-0">
                <data-filter
                    :tableLength="totalRecords"
                    v-model="filter"
                ></data-filter>
            </CCol>
        </CRow>
        <CRow v-if="loading">
            <CCol sm="12" class="text-center">
                <div>
                    <pulse-loader :loading="loading" color="green"></pulse-loader>
                </div>
            </CCol>
        </CRow>
        <CRow>            
            <CCol md="12" class="pad-r-0 pad-l-0">
                
                <CCard>
                    <CCardHeader>
                        <i>New Update: <span class="text-danger">Identity names marked in red are cases where the names does not match with names available in the database!</span></i>
                    </CCardHeader>
                    <CCardBody >
                        <b-table 
                            hover
                            selectable
                            select-mode="single"
                            @row-selected="onSelectRow"
                            :items="items"
                            :fields="fields"
                            style="cursor : pointer"
                            id="reportTable"
                            :per-page="perPage"
                            :current-page="currentPage"
                        >
                            <template v-slot:cell(dateOfAdmission)="data">
                                {{data.item.dateOfAdmission != null ? data.item.dateOfAdmission.substring(0,10) : '-'}} 
                            </template>
                            <template v-slot:cell(dateOfOutcome)="data">
                                {{data.item.dateOfOutcome != null ? data.item.dateOfOutcome.substring(0,10) : '-'}} 
                            </template>
                            <template v-slot:cell(animalData)="data">
                                <span v-if="data.item.animalData.identityName != undefined">{{data.item.animalData.identityName}}</span>
                                <span v-else-if="data.item.identityName != undefined" class="text-danger">{{data.item.identityName}}</span>
                                <span v-else>-</span>
                            </template>
                            <template v-slot:cell(finalDisposition)="data">
                                {{(data.item.finalDisposition != null && data.item.finalDisposition != "") ? data.item.finalDisposition : '-'}} 
                            </template>
                            <template v-slot:cell(causeofdisplacement)="data">
                                {{(data.item.displacement != null && data.item.displacement != "") ? data.item.displacement : '-'}} 
                            </template>
                            <template v-slot:cell(zoneName)="data">
                                {{data.item.zoneName != null ? data.item.zoneName : '-'}} 
                            </template>
                            <template v-slot:cell(dateAdded)="data">
                                {{data.item.dateAdded != null ? data.item.dateAdded.substring(0,10) : '-'}} 
                                <!-- <i>{{new Date(new Date(data.item.dateAdded).getTime() - 19800000) | moment("from")}}</i> -->
                            </template>
                           
                        </b-table>
                        <b-pagination 
                            align="center"
                            v-model="currentPage"
                            :total-rows="items.length"
                            :per-page="perPage"
                            @page-click="loadMore"
                            aria-controls="reportTable"
                        ></b-pagination>
                        
                    </CCardBody>
                    <CCardFooter class="text-center" v-if="download.length > 0">
                        <json-excel
                            :data = "download"
                            :name = "filename"
                        >
                        <CButton color="info" style="float : center"> Export as excel </CButton>
                        </json-excel>
                    </CCardFooter>
                </CCard>

            </CCol>            
        </CRow>
    </div>
</template>

<script>

import DataFilter from './components/dataFilter.vue';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import axios from 'axios';
import store from '../store';
import JsonExcel from 'vue-json-excel';

export default {
    name : 'PendingCases',
    components: {
        DataFilter,
        PulseLoader,
        JsonExcel
    },
    props : {
        small : true,
        
    },
    data() {
        return {
            baseURL : store.state.baseURL,

            showFilter : false,
            items: [
            ],
            filename : 'SaveAnimals_DB_Pending_Cases.xls',
            selected : {
            },
            filter : {
                fromDate : null,
                toDate : null,
                class : null,
                family : null,
                group : null,
                identity : null,
                scientific : null,
                zone : null,
                outcome : null,
                timeType : null,
                date : null,
                timeIntervalType : null,
                caseno : null,
                stage : null,
                facility : null,
                placeOfRescue : null,
                causeOfDisp : null
            },
            perPage: 12,
            currentPage: 1,
            tableLength : 0,
            totalRecords : 0,

            filterLoading : true,
            loading : true,
            fields : [
                {
                    key : 'caseNumber',
                    label : 'Case No',
                    sortable : true
                },
                {
                    key : 'animalData',
                    label : 'Identity',
                    sortable : true
                },
                {
                    key : 'zoneName',
                    label : 'Zone',
                    sortable : true
                },
                {
                    key : 'finalDisposition',
                    label : 'Outcome',
                    sortable : true
                },
                {
                    key : 'causeofdisplacement',
                    label : 'Cause of Displacement',
                    sortable : true
                },
                {
                    key : 'dateOfAdmission',
                    label : 'Date (Admission)',
                    sortable : true
                },
                {
                    key : 'dateOfOutcome',
                    label : 'Date (Outcome)',
                    sortable : true
                },
                {
                    key : 'dateAdded',
                    label : 'Case Added',
                    sortable : true
                },

                // {
                //     key : 'finalDisposition',
                //     label : "Final Outcome"
                // }
            ],
            download : [],

            loadPage : 1,
            pagesAvailable : 1
            
        }
    },
    beforeMount(){
        var d = new Date();
        var str = d.toISOString();
        str = str.substr(0, 10);
        str = str.replace(/-/g, '');
        this.filename = 'Incomplete_List_SaveAnimals_DB_'+ str +'.xls';
    },
    created() {
        this.loading = true;
        this.selected = {
            sourceIntervalType : store.state.filters.sourceIntervalType,
            sourceType : store.state.filters.sourceype,
            date : store.state.filters.date,
            startDate : store.state.filters.startDate,
            endDate : store.state.filters.endDate,
            outcome : store.state.filters.outcome,
            zone : store.state.filters.zone,
            class : store.state.filters.class,
            family : store.state.filters.family,
            group : store.state.filters.group,
            identity : store.state.filters.identity,
            caseno : store.state.filters.caseno,
            scientific : store.state.filters.scientific,
            stage : store.state.filters.stage,
            facility : store.state.filters.facility,
            placeOfRescue : store.state.filters.placeOfRescue,
            causeOfDisp : store.state.filters.causeOfDisp,
            month : store.state.filters.month,
            year : store.state.filters.year,
        }

        this.filter = {
            fromDate : this.selected.startDate,
            toDate : this.selected.endDate,
            class : this.selected.class,
            family: this.selected.family,
            group : this.selected.group,
            identity : this.selected.identity,
            scientific : this.selected.scientific,
            zone : this.selected.zone,
            outcome : this.selected.outcome,
            timeType : this.selected.sourceType,
            date : this.selected.date,
            timeIntervalType : this.selected.sourceIntervalType,
            caseno : this.selected.caseno,
            stage : this.selected.stage,
            facility : this.selected.facility,
            placeOfRescue : this.selected.placeOfRescue,
            causeOfDisp : this.selected.causeOfDisp
        }
    },
    watch : {
        filter : function(newVal, oldVal){
            this.getRecords(true);
        }
    },
    methods: {
        loadMore(){
            ++this.loadPage;
            if(this.tableLength == this.items.length){
                
            }
            else{

                this.getRecords(false);

            }

        }, 

        makeDownloadable(records){
            this.download = [];
            for(var x in records){         

                this.download.push({     
                    "Case ID" : records[x].caseNumber,
                    "Case Status" : records[x].status,
                    "Zone" : records[x].zoneName, 
                    "Wrong Species Name" : records[x].wrongSpecies != null ? records[x].wrongSpecies : "",            
                    "Species" : records[x].animalData != null ? records[x].animalData.identityName : "",
                    "Rescue type" : records[x].rescueType != null ? records[x].rescueType : "",
                    "Date of rescue/displacement" : records[x].dateOfRescue != null ? records[x].dateOfRescue.substring(0,10) : "",
                    "Place of rescue" : records[x].placeOfRescue != null ? records[x].placeOfRescue : "",
                    "Coordinates of place of rescue Lat" : records[x].gpsLatitudeRescue != null ? records[x].gpsLatitudeRescue : "",
                    "Coordinates of place of rescue Long" : records[x].gpsLongditudeRescue != null ? records[x].gpsLongditudeRescue : "",
                    "Cause of displacement" : records[x].displacement != null ? records[x].displacement : "",
                    "Details of intervention" : '',
                    "Type of intervention (in situ/ex situ)" : records[x].rescueMode != null ? records[x].rescueMode : "",
                    "Rescued by" : records[x].rescuedBy != null ? records[x].rescuedBy : "",
                    "Date of admission/intervention" : records[x].dateOfAdmission != null ? records[x].dateOfAdmission.substring(0,10) : "",
                    "Stage" : records[x].stage != null ? records[x].stage : "",
                    "Sex" : records[x].sex != null ? records[x].sex : "",
                    "Weight" : records[x].weight != null ? records[x].weight : "",
                    "Length (Approx)" : records[x].length != null ? records[x].length : "",
                    "Outcome" : records[x].finalDisposition != null ? records[x].finalDisposition : "",
                    "Date of outcome" : records[x].dateOfOutcome != null ? records[x].dateOfOutcome.substring(0,10) : "",
                    "Place of outcome" : records[x].placeOfOutcome != null ? records[x].placeOfOutcome : "",
                    "Coordinates of place of release Lat" : records[x].gpsLatitudeRelease != null ? records[x].gpsLatitudeRelease : "",
                    "Coordinates of place of release Long" : records[x].gpsLongditudeRelease != null ? records[x].gpsLongditudeRelease : "",
                    "Remarks" : records[x].remarks != null ? records[x].remarks : "",  
                    // "Error - Species"   : records[x].errorAnimalData != null ? records[x].errorAnimalData : "NULL",
                    // "Error - Outcome"   : records[x].errorFinalDisposition != null ? records[x].errorFinalDisposition : "NULL",
                    // "Error - Date of Admission" : records[x].errorDateAdmission != null ? records[x].errorDateAdmission : "NULL",
                    // "Error - Date of Outcome"   : records[x].errorDateOutcome != null ? records[x].errorDateOutcome : "NULL",
                });
            }

        }, 
    
        getRecords(reset){
            this.loading = true;
            axios({
                url : this.baseURL + "records/pending-cases?p="+this.loadPage,
                headers : {
                    authorization : store.state.token
                },
                data : this.filter,
                method : "POST"
            })
            .then(res => {
                if(res.data.status)
                {              
                    if(reset)      
                        this.items = res.data.data;
                    else
                        this.items.push(...res.data.data);

                    this.totalRecords = res.data.count;
                    this.tableLength = res.data.count;
                    
                    this.pagesAvailable = res.data.pages;
                    this.makeDownloadable(this.items);    
                    
                    if(this.items.length == 0){
                        this.$notify({
                            group: 'notification',
                            type : 'error',
                            title: 'Important message',
                            text: "Zero records found!"
                        });
                    }
                }
                else
                {
                    this.items = []
                    this.tableLength = 0;
                    this.$notify({
                        group: 'notification',
                        type : 'error',
                        title: 'Important message',
                        text: res.data.message
                    });
                }
                this.loading = false;
            })
            .catch(err => {
                this.$notify({
                    group: 'notification',
                    type : 'error',
                    title: 'Important message',
                    text: 'Error in loading data. Something went wrong!'
                });
                console.log(err);
                this.loading = false;
                return [];
            });

        },
        
        onSelectRow(row){
            this.openReport(row[0]._id);

        },
        selectAnimal(item){
        },
        openReport(id){
            window.open(`/edit-case/${id}`, '_blank');
            // this.$router.push({name : 'Conflict Report', params : { surveyid }});
        }
    }
}
</script>

<style scoped>
    .pad-r-0 {
        padding-right: 0px !important;
    }
    .pad-l-0 {
        padding-left: 0px !important;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>